import React from 'react'
import MinesGames from '../../components/Mines'

const Mines = ({ balance,setBalance }) => {
  return (
    <div>
      <MinesGames balance={balance} setBalance={setBalance}/>
    </div>
  )
}

export default Mines